<header class="flex gap-3 w-full">
  <!-- back button -->
  <ui-button
    class="flex-none hidden md:inline"
    mode="outlined"
    [routerLink]="['/organizations', organizationId(), 'supplier-contracts']"
  >
    <ng-icon name="heroArrowLeftStartOnRectangle" size="20" slot="start" class="!block" />
    {{ 'cockpit.parseRequests.createHeader.leaveButton' | transloco }}
  </ui-button>
  <ui-button
    class="flex-none md:hidden"
    mode="outlined"
    [iconOnly]="true"
    [routerLink]="['/organizations', organizationId(), 'supplier-contracts']"
  >
    <ng-icon name="heroArrowLeftStartOnRectangle" size="20" class="!block" />
  </ui-button>
  <div class="flex gap-6 w-full items-center">
    <!-- title -->
    <h1 class="flex-1 font-bold text-xl md:text-3xl line-clamp-1">
      {{ 'cockpit.parseRequests.createHeader.title' | transloco }}
    </h1>
    <div class="flex gap-3">
      <!-- feedback button -->
      <ui-button
        mode="outlined"
        class="hidden md:inline"
        appSentryFeedback
        *appTechnicalMonitoringEnabled
      >
        <ng-icon name="heroMegaphone" size="20" slot="start" class="!block" />
        {{ 'help.feedbackFab.buttonLabel' | transloco }}
      </ui-button>
      <ui-button
        mode="outlined"
        [iconOnly]="true"
        class="md:hidden"
        appSentryFeedback
        *appTechnicalMonitoringEnabled
      >
        <ng-icon name="heroMegaphone" size="20" class="!block" />
      </ui-button>
      <!-- info button -->
      <a
        [href]="headerBarInfoButtonLink()"
        target="_blank"
        [title]="'cockpit.parseRequests.createHeader.infoButtonTitle' | transloco"
        class="flex-none"
        *appFeatureEnabled="'helpCenter'"
      >
        <ui-button [iconOnly]="true" mode="outlined" class="md:hidden">
          <ng-icon name="heroInformationCircle" size="20" class="!block" />
        </ui-button>
        <ui-button mode="outlined" class="hidden md:inline">
          <ng-icon name="heroInformationCircle" size="20" class="!block" slot="start" />
          {{ 'cockpit.parseRequests.createHeader.moreInfoButtonLabel' | transloco }}
        </ui-button>
      </a>
    </div>
  </div>
</header>
